import { Component, Input, EventEmitter, Output } from '@angular/core';



/**
   * Logger Factory
   * @namespace items: menu item to show
   * @namespace alignLeft: if true the box is aligned to left 
   * @namespace clickItem: is the action brought to the parent
   * <ute-menu-dropdown [items]="menuitems" (clickItem)="onClickItem($event)"></ute-menu-dropdown>
*/

@Component({
  selector: 'ute-menu-dropdown',
  templateUrl: 'ute-menu-dropdown.component.html'
})
export class UteMenuDropdown {
  @Input() items: any;
  @Input() title: any;
  @Input() icon: any;
  @Input() alignLeft: boolean = false;
  @Output() clickItem = new EventEmitter;

  public isOpen: boolean = false;

  constructor() {}

  openDropdown(){
    this.isOpen = !this.isOpen;
  }

  onClickItem(action){
    this.clickItem.emit(action);
    this.isOpen = !this.isOpen;
  }

  // ngOnChanges(change: SimpleChanges){
  //   if(change ){
  //     console.log(change.items, change.icon);
  //     this.title = change.title.currentValue;
  //     this.items = change.items.currentValue;
  //     this.icon = change.icon.currentValue;
  //   }
  // }
}


// WEBPACK FOOTER //
// ./src/app/components/molecules/ute-menu-dropdown/ute-menu-dropdown.component.ts